import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-010dbc6c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "schedule" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "iframeanchor",
  "data-iframe-height": ""
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_event_swiper = _resolveComponent("event-swiper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_event_swiper, {
      data: _ctx.activeTimers,
      categories: _ctx.route.params.category ? [_ctx.route.params.category] : [],
      versions: _ctx.selectedVersions,
      sections: _ctx.selectedSections,
      "version-num": _ctx.versionNum,
      "no-padding": true
    }, null, 8, ["data", "categories", "versions", "sections", "version-num"]),
    _hoisted_2
  ]))
}